import { FocusEventHandler } from "react";

export const handleInputFocus: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
    event.target.select();
};
